import { Component, OnInit } from '@angular/core';
import { Router,NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-package-dashboard',
  templateUrl: './package-dashboard.component.html',
  styleUrls: ['./package-dashboard.component.scss']
})
export class PackageDashboardComponent implements OnInit {

  navigationSubscription;
  suppTabActive: boolean = true;
  userRoleID: any;
  constructor(private router: Router) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initialiseInvites();
      }
    });
   }

  ngOnInit() {
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
   }
   
  initialiseInvites(){
    
  }

}
